import * as actionTypes from './actionTypes'

import { enqueueSnackbar } from './alert'
import verticalForceRank from '../../axios/verticalForceRank'
import forceRankAxios from '../../axios/forceRank'

export const createVerticalForceRank = (recordData, page) => {
  return dispatch => {
    dispatch(createVerticalForceRankStart())

    verticalForceRank
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Vertical Force Rank Save',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createVerticalForceRankSuccess())
          window.location.reload()
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'InvalidverticalGradeField',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createVerticalForceRankFailed())
      })
  }
}

export const createVerticalForceRankStart = () => {
  return {
    type: actionTypes.CREATE_VERTICAL_FORCERANK_START
  }
}
export const createVerticalForceRankSuccess = () => {
  return {
    type: actionTypes.CREATE_VERTICAL_FORCERANK_SUCCESS
  }
}
export const createVerticalForceRankFailed = () => {
  return {
    type: actionTypes.CREATE_VERTICAL_FORCERANK_FAILED
  }
}

export const fetchVerticalForceRankFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchVerticalForceRankFilterCompanyStart())
    verticalForceRank
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchVerticalForceRankFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchVerticalForceRankFilterCompanyFailed(error))
      })
  }
}

export const fetchVerticalForceRankFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_START
  }
}

export const fetchVerticalForceRankFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchVerticalForceRankFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchVerticalForceRankGrade = () => {
  return dispatch => {
    dispatch(fetchVerticalForceRankGradeStart())
    forceRankAxios
      .get('/grade_and_count_force_rank')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchVerticalForceRankGradeSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchVerticalForceRankGradeFailed(error))
      })
  }
}

export const fetchVerticalForceRankGradeStart = () => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_GRADE_START
  }
}

export const fetchVerticalForceRankGradeSuccess = data => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_GRADE_SUCCESS,
    data
  }
}

export const fetchVerticalForceRankGradeFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_GRADE_FAILED,
    errorMessage
  }
}

// Force Rank List

export const fetchVerticalForceRankList = data => {
  return dispatch => {
    dispatch(fetchVerticalForceRankListStart())
    verticalForceRank
      .post('/vertical', data)
      .then(response => {
        // if (response.status === 200) {
        //   dispatch(fetchForceRankListSuccess(response.data.data))
        // }
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'ForceRankSuccess',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchVerticalForceRankListSuccess(response.data.data))
        }
      })
      // .catch(error => {
      //   dispatch(fetchForceRankListFailed(error))
      // })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'ForceRankFailed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchVerticalForceRankListFailed())
      })
  }
}

export const fetchVerticalForceRankListStart = () => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_LIST_START
  }
}

export const fetchVerticalForceRankListSuccess = data => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_LIST_SUCCESS,
    data
  }
}

export const fetchVerticalForceRankListFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_LIST_FAILED,
    errorMessage
  }
}

// Force Rank List (2)

export const fetchReStoreVerticalForceRankList = data => {
  return dispatch => {
    dispatch(fetchReStoreVerticalForceRankListStart())
    verticalForceRank
      .post('/vertical', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchReStoreVerticalForceRankListSuccess(response.data.data))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'ForceRankFailed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchReStoreVerticalForceRankListFailed())
      })
  }
}

export const fetchReStoreVerticalForceRankListStart = () => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_LIST_START
  }
}

export const fetchReStoreVerticalForceRankListSuccess = data => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_LIST_SUCCESS,
    data
  }
}

export const fetchReStoreVerticalForceRankListFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_LIST_FAILED,
    errorMessage
  }
}

export const fetchVerticalForceRankCalculate = data => {
  // let params = null
  // if (filterOptions) {
  //     params = filterOptions
  // }
  return dispatch => {
    dispatch(fetchVerticalForceRankCalculateStart())
    verticalForceRank
      .post('/calculate', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchVerticalForceRankCalculateSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchVerticalForceRankCalculateFailed(error))
        dispatch(
          enqueueSnackbar({
            message: error?.response?.data?.data?.error || 'ForceRank Grade Calculate Failed',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const fetchVerticalForceRankCalculateStart = () => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_CALCULATE_START
  }
}

export const fetchVerticalForceRankCalculateSuccess = data => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_CALCULATE_SUCCESS,
    data
  }
}

export const fetchVerticalForceRankCalculateFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_CALCULATE_FAILED,
    errorMessage
  }
}

// vertical

export const fetchVerticalForceRank = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchVerticalForceRankStart())
    verticalForceRank
      .get('', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchVerticalForceRankSuccess(response.data.data))
        }
      })
      .catch(error => {
        switch (error.response?.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'VerticalForceRankFailed DataEmpty',
                options: {
                  variant: 'error'
                  // data: error.response.data.data
                }
              })
            )
            break
          case 404:
            dispatch(
              enqueueSnackbar({
                message: 'VerticalForceRankFailed',
                options: {
                  variant: 'error'
                  // data: error.response.data.data
                }
              })
            )
            break
          default:
            dispatch(
              enqueueSnackbar({
                message: error.response?.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchVerticalForceRankFailed(error))
      })
  }
}

export const fetchVerticalForceRankStart = () => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_START
  }
}

export const fetchVerticalForceRankSuccess = data => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_SUCCESS,
    data
  }
}

export const fetchVerticalForceRankFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_VERTICAL_FORCERANK_FAILED,
    errorMessage
  }
}
